import { Component, ViewChild, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-authority-contacted',
    templateUrl: './authority-contacted.component.html',
    styleUrls: ['./authority-contacted.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonModule
    ]
})
export class AuthorityContactedComponent implements OnInit {
  form: UntypedFormGroup;
  @ViewChild('organization', { static: false }) organizationInput: any;
  
  constructor(private readonly fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.form = this.createForm();
  }

  createForm(): UntypedFormGroup {
    return this.fb.group({
      organizationName: [''],
      officerName: [''],
      badgeNumber: [''],
      reportNumber: [''],
      violations: [''],
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.organizationInput?.nativeElement?.focus();
    }, 0);
  }

}
